import React from 'react'
import PropTypes from 'prop-types'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faStar } from '@fortawesome/pro-solid-svg-icons'

const StarRating = (props) => {
  const { value, style, className } = props

  const stars = Array(value).fill(0).map((v, k) => k)

  return (
    <div className={className} style={style}>
      {stars.map(v => (
        <FontAwesomeIcon icon={faStar} key={`stars_${v}`} />
      ))}
    </div>
  )
}

StarRating.propTypes = {
  className: PropTypes.string,
  style: PropTypes.object,
  value: PropTypes.number.isRequired,
}

export default StarRating
